// extracted by mini-css-extract-plugin
export default {"authorization":"css_authorization__wTL8G"};